import { IOrderbook } from "src/Interfaces/orderbook";
import { orderbookApiAddress } from "./config";
import { getRequest, postRequest } from "./requestTemplates";

const baseURL = orderbookApiAddress();

export const getOrderbooks = (): Promise<IOrderbook[]> =>
  getRequest("/api/OrderBook", { baseURL });

export const setOrderbooks = (
  orderbooks: IOrderbook[],
): Promise<IOrderbook[]> =>
  postRequest("/api/OrderBook", orderbooks, { baseURL });
